/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {searchTeamMemberAvailability} from '../api'

export const useMutationSearchTeamMemberAvailability = createReactQueryMutationHook('searchTeamMemberAvailability', searchTeamMemberAvailability)
